import { render, staticRenderFns } from "./v-select.vue?vue&type=template&id=37ac5166&scoped=true"
import script from "./v-select.vue?vue&type=script&lang=js"
export * from "./v-select.vue?vue&type=script&lang=js"
import style0 from "./v-select.vue?vue&type=style&index=0&id=37ac5166&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../com-tool/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ac5166",
  null
  
)

export default component.exports